module.exports = __webpack_public_path__ + "static/media/circle-background.ae92ebf1.jpg";